import React from 'react';

import CourseHeading from '../../BookLandingPageComp/landingPage/heading/CourseHeading';
export type CourseIncludes = {
  icon: JSX.Element;
  label: string;
  value: string;
};

const CourseIncludesSection: React.FC<{ data: CourseIncludes[] }> = ({
  data,
}) => {
  return (
    <div className='flex flex-col '>
      <CourseHeading heading='This course includes' />

      <div className='grid grid-cols-1 sm:grid-cols-2 gap-3'>
        {data?.map((detail, index) => (
          <div
            key={`${detail?.label}-${index}`}
            className='flex items-center gap-3'
          >
            <span className='text-xl'>{detail.icon}</span>
            <div className='flex items-center gap-x-2'>
              <p className='text-sm font-semibold'>{detail.value}</p>
              <p className='text-sm text-[#FFFFFF99] pt-[1px] '>
                {detail.label}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CourseIncludesSection;
